export enum FilterOperator {
  AND, OR, EXCLUDE
}
